import toast from "react-hot-toast";

// API Error Handler
export const handleApiError = (error, customMessage = null) => {
  console.error("API Error:", error);

  const message =
    customMessage || error.message || "An unexpected error occurred";

  // Show toast notification
  toast.error(message, {
    duration: 4000,
    position: "top-right",
    style: {
      background: "#1A1A1A",
      color: "#ffffff",
      border: "1px solid #3A3A3A",
    },
  });

  return message;
};

// API Success Handler
export const handleApiSuccess = (message, data = null) => {
  console.log("API Success:", message, data);

  toast.success(message, {
    duration: 3000,
    position: "top-right",
    style: {
      background: "#1A1A1A",
      color: "#ffffff",
      border: "1px solid #FF9900",
    },
  });

  return data;
};

// Loading toast
export const showLoadingToast = (message = "Loading...") => {
  return toast.loading(message, {
    style: {
      background: "#1A1A1A",
      color: "#ffffff",
      border: "1px solid #3A3A3A",
    },
  });
};

// Dismiss toast
export const dismissToast = (toastId) => {
  toast.dismiss(toastId);
};

// Format API validation errors
export const formatValidationErrors = (errors) => {
  if (Array.isArray(errors)) {
    return errors.join(", ");
  }
  if (typeof errors === "object") {
    return Object.values(errors).flat().join(", ");
  }
  return errors;
};
